var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import { decl, bool2string } from '@yandex-lego/i-bem-react';

var i18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./attach.i18n/ru'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./attach.i18n/en'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./attach.i18n/be'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./attach.i18n/id'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./attach.i18n/kk'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./attach.i18n/tr'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./attach.i18n/tt'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./attach.i18n/uk'))('attach');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uz' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uz' : 'en' === 'uz') {
        return core().decl(require('./attach.i18n/uz'))('attach');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
    }

    return function () {};
}();

import "./../button2/button2.react.js";
import _button2_hasControl_yes from "./../button2/_has-control/button2_has-control_yes.react.js";

var Button = _button2_hasControl_yes.applyDecls();

import "./../button2/button2.css";
import "./../../desktop.blocks/button2/button2.css";
import "./../button2/_theme/button2_theme_normal.css";
import "./../../desktop.blocks/button2/_theme/button2_theme_normal.css";
import "./../button2/_size/button2_size_s.css";
import "./../button2/_size/button2_size_m.css";
import "./__control/attach__control.css";
import _attach__holder from "./__holder/attach__holder.react.js";

var Holder = _attach__holder.applyDecls();

import "./__holder/attach__holder.css";
import "./__holder/_state/attach__holder_state_hidden.css";


export default decl({
    block: 'attach',
    tag: 'span',

    willInit: function willInit(_ref) {
        var disabled = _ref.disabled,
            holder = _ref.holder;

        this.__base.apply(this, arguments);

        // Условие на случай, если holder передано без значения
        this._noFileText = typeof holder === 'string' ? holder : '';

        this.state = {
            fileText: this._noFileText
        };

        this.onChange = this.onChange.bind(this);
        this.onResetClick = this.onResetClick.bind(this);
    },
    mods: function mods(_ref2) {
        var theme = _ref2.theme,
            size = _ref2.size,
            disabled = _ref2.disabled;

        return {
            theme: theme,
            size: size,
            disabled: bool2string(disabled)
        };
    },
    attrs: function attrs(_ref3) {
        var _attrs = _ref3.attrs;
        var disabled = this.state.disabled;


        return _extends({
            onChange: disabled ? undefined : this.onChange
        }, _attrs);
    },
    content: function content(_ref4) {
        var _this = this;

        var theme = _ref4.theme,
            size = _ref4.size,
            textWidth = _ref4.textWidth,
            disabled = _ref4.disabled,
            _ref4$id = _ref4.id,
            id = _ref4$id === undefined ? this.generateId() : _ref4$id,
            name = _ref4.name,
            tabIndex = _ref4.tabIndex,
            holder = _ref4.holder,
            controlAttrs = _ref4.controlAttrs,
            children = _ref4.children;
        var _state = this.state,
            fileText = _state.fileText,
            hasFile = _state.hasFile;

        var ext = this._ext;

        name || (name = 'attachment');

        return [React.createElement(
            Button,
            _extends({
                theme: theme, size: size, disabled: disabled,
                id: id, name: name,
                hasControl: true,
                control: {
                    mix: { block: 'attach', elem: 'control' },
                    type: 'file',
                    attrs: _extends({
                        'aria-labelledby': 'text' + id,
                        ref: function ref(input) {
                            return _this.input = input;
                        }
                    }, controlAttrs)
                },
                mix: { block: 'attach', elem: 'button' },
                tabIndex: tabIndex
            }, { key: 'button' }),
            children || i18n('button-text')
        )].concat(holder ? React.createElement(
            Holder,
            _extends({ textWidth: textWidth }, {
                id: id, hasFile: hasFile, ext: ext,
                onResetClick: this.onResetClick
            }, { key: 'holder' }),
            fileText
        ) : []);
    },
    onChange: function onChange(e) {
        this._setFilePath(e.target.value);

        this.props.onChange && this.props.onChange(e, this.props);
    },
    onResetClick: function onResetClick(e) {
        this.input.value = '';
        this._setFilePath('');

        // NOTE: Do we need such API ??
        this.props.onChange && this.props.onChange({ target: this.input }, this.props);
        this.props.onReset && this.props.onReset({ target: this.input }, this.props);
    },


    _setFilePath: function _setFilePath(filePath) {
        var fileName = void 0;
        var fileExtension = void 0;

        if (filePath) {
            fileName = filePath.split('\\').pop();
            fileExtension = fileName.split('.').pop().toLowerCase();
        } else {
            fileName = this._noFileText;
        }

        this._ext = this.__self.extensionsToMods[fileExtension] || this.__self._unknownType;
        this.setState({
            fileText: fileName,
            hasFile: Boolean(filePath)
        });
    }
}, {
    propTypes: {
        theme: PropTypes.string.isRequired,
        size: PropTypes.oneOf(['s', 'm']),
        id: PropTypes.string,
        name: PropTypes.string,
        tabIndex: PropTypes.string,
        onChange: PropTypes.func,
        onReset: PropTypes.func
    },

    _unknownType: 'unknown',

    /**
     * @public
     */
    extensionsToMods: {
        zip: 'archive',
        rar: 'archive',
        tar: 'archive',
        gz: 'archive',
        '7z': 'archive',
        gif: 'gif',
        jpg: 'jpg',
        jpeg: 'jpg',
        png: 'png',
        eml: 'eml',
        exe: 'exe',
        m4a: 'audio',
        ogg: 'audio',
        mp3: 'mp3',
        wav: 'wav',
        wma: 'wma',
        flv: 'video',
        mov: 'mov',
        wmv: 'wmv',
        mp4: 'mp4',
        avi: 'avi',
        xls: 'xls',
        doc: 'doc',
        docx: 'doc',
        txt: 'txt',
        pdf: 'pdf',
        ppt: 'ppt'
    }
});